<template>
  <div v-show="pageCount > 1" class="v-paginator">
    <button :disabled="pageNumber === 0" @click="prevPage">
        &lsaquo;
    </button>
    <button :disabled="pageNumber >= pageCount -1" @click="nextPage">
        &rsaquo;
    </button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      pageNumber: 0
    }
  },
  props:{
    records: {
      type:Array,
      required:true
    },
    size: {
      type: Number,
      required: false,
      default: 3,
    }
  },
  mounted() {
    this.returnPagination();
  },
  methods:{
    nextPage() {
      this.pageNumber++;
      this.returnPagination();         
    },
    prevPage() {
      this.pageNumber--;
      this.returnPagination();
    },
    returnPagination() {
      this.$emit('return-pagination', {
        results: this.paginated,
        page: this.pageNumber
      });
    }
  },
  computed:{
    pageCount(){
      let l = this.records.length,
          s = this.size;
      return Math.ceil(l/s);
    },
    paginated(){
      const start = this.pageNumber * this.size,
            end = start + this.size;
      return this.records
               .slice(start, end);
    }
  },
}
</script>